import { styled, Tooltip, tooltipClasses, TooltipProps, Typography } from '@mui/material'
import React from 'react'

export const PreformattedTooltip = styled(({ className, title, ...props }: TooltipProps) => {
  return (
    <Tooltip
      title={<Typography component={'pre'}>{title}</Typography>}
      {...props}
      classes={{
        popper: className,
      }}
    />
  )
})({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: '100%',
  },
})
